module.exports = __webpack_public_path__ + "static/media/app-store.1e5d365d.png";